 const catagoryInfos = [
    {
        title: "Electronics",
        name: "electronics",
        imgLink: "https://m.media-amazon.com/images/I/71Is-Zv6A0L._AC_UY327_FMwebp_QL65_.jpg",
    },
    {
        title: "Discover fashion trends",
        name: "Women's clothing",
        imgLink: "https://static3.depositphotos.com/1000647/118/i/450/depositphotos_1189280-stock-illustration-lady.jpg",
    },
    {
        title: "Men's clothing",
        name: "men's clothing",
        imgLink: "https://st4.depositphotos.com/16122460/23891/i/600/depositphotos_238915516-stock-photo-wardrobe-rack-men-clothes-grey.jpg",
    },
    {
        title: "Jewelery",
        name: "jewelery",
        imgLink: "https://m.media-amazon.com/images/I/51jcDOkj82L._AC_SY695_.jpg",
    }
]
export default catagoryInfos